import React from "react"
import { SubText, Text } from "../GameRulesStyles"

export default function GeneralRules() {
  return (
    <>
      <Text className={"big red"} margin={"0 0 10px"}>
        General conditions
      </Text>
      <Text className={"big white"} margin={"0 0 10px"}>
        Please refer to the conditions and cases that characterize the game
        based on its specifications AND GAMEPLAY TYPE.
      </Text>
      <Text className={"small white"} margin={"0 0 20px"}>
        <SubText className={"green"}>delayed cashout</SubText> It may happen in
        the game that you click{" "}
        <SubText className={"green"}> cashout, </SubText> but the spaceship{" "}
        <SubText className={"red"}> explodes</SubText>, and your{" "}
        <SubText className={"blue"}> bet </SubText> is considered{" "}
        <SubText className={"red"}> lost</SubText>, this happens due to lag,
        which can occur even in{" "}
        <SubText className={"green"}> good internet</SubText> conditions, so to
        avoid this risk, we recommend you use the{" "}
        <SubText className={"blue"}> autocashout</SubText> function
      </Text>
      <Text className={"small white"} margin={"0 0 24px"}>
        *ERROR MAY OCCUR:<SubText className={"red"}> stage timeout</SubText>
      </Text>
      <Text className={"small white"} margin={"0 0 16px"}>
        <SubText className={"red"}>WHAT IF GET DISCONNECTED?</SubText> - In case
        you encounter a <SubText className={"red"}>connection problem</SubText>{" "}
        or accidentally <SubText className={"blue"}>refresh the page</SubText>,
        the game condition will be as follows:
      </Text>
      <Text className={"small white"} margin={"0 0 16px"}>
        <SubText className={"blue"}>manual bet</SubText> - will continue as far
        as this round can go and you will be presented with the{" "}
        <SubText className={"green"}>cashout button</SubText> as it was before
        <SubText className={"red"}> disconnection</SubText>
      </Text>
      <Text className={"small white"} margin={"0 0 16px"}>
        <SubText className={"red"}>autopilot bet</SubText> - will continue as
        far as this round can go and you will be presented with the{" "}
        <SubText className={"green"}>cashout button</SubText> as it was before
        <SubText className={"red"}> disconnection,</SubText> BUT AUTOPILOT’S
        FOLLOWING BETS WILL BE <SubText className={"red"}>canceled</SubText> To
        avoid placing automatic bets and spending your balance without your
        supervision in case of{" "}
        <SubText className={"red"}>long connection problem.</SubText>
      </Text>
      <Text className={"small white"} margin={"0 0 16px"}>
        *in case of <SubText className={"green"}>autocashout</SubText> feature
        enabled GAME WILL AUTOMATICALLY WITHDRAW the specified amount THAT YOU
        HAVE INDICATED IN
        <SubText className={"red"}> autopilot</SubText>
      </Text>
      <Text className={"white"} margin={"0 0 16px"}>
        Malfunction voids all pays and plays.
      </Text>
      <Text className={"white"} margin={"0 0 20px 0"}>
        The cashout button becomes available for use when the game multiplier
        reaches or exceeds 1.01x. If the explosion happens, the stake is
        considered as lost.
      </Text>
    </>
  )
}
